export default __webpack_public_path__ + "img/ic-report.607b9fd1.svg";